<template>
  <div class="lanhu-page page flex-col">
    <div class="box_1 flex-row">
      <div class="box_1_1">
        <img class="image_1" src="/static/assets/img/ncportal/image_1.png">
        <span class="text_1">南昌技师学院培训服务平台</span>
        <span class="text_2">服务热线0791-88503816</span>
      </div>
    </div>
    <div class="box_2 flex-col">
      <div class="group_17 flex-row">
        <div class="lanhu-nav-item flex-col"><a href="/" class="text_58 lanhu-nav-active">首页</a>
          <div class="group_18 flex-col lanhu-nav-underline"></div>
        </div>
        <div class="lanhu-nav-item flex-col" style="margin-left:84px"><a href="/portal/newlist?t=3" class="text_59">培训要闻</a></div>
        <div class="lanhu-nav-item flex-col" style="margin-left:75px"><a href="/portal/newlist?t=4" class="text_60">干部培训</a></div>
        <div class="lanhu-nav-item flex-col" style="margin-left:75px"><a href="/portal/newlist?t=5" class="text_61">技能培训</a></div>
        <div class="lanhu-nav-item flex-col" style="margin-left:75px"><a href="/portal/newlist?t=6" class="text_62">特种培训</a></div>
        <div class="lanhu-nav-item flex-col" style="margin-left:75px"><a href="/portal/newlist?t=7" class="text_63">专项培训</a></div>
        <div class="lanhu-nav-item flex-col" style="margin-left:75px;"><a href="/portal/newlist?t=8" class="text_64">评价通告</a></div>
      </div>
    </div>
    <div class="flex-col">

      <div class="group_15 flex-col lanhu-banner" style="--lanhu-banner:url('/static/assets/img/ncportal/group_15.png')">
        <div class="group_16 flex-row justify-between">
          <div class="text-group_8 flex-col justify-between"><span class="text_54">南昌技师学院</span><span class="text_55">南昌市市级工匠学院</span></div>
          <div class="text-wrapper_11 flex-col justify-between"><span class="text_56">南昌市公共实训基地</span><span class="text_57">江西省高技能人才培训基地</span></div>
        </div>
        <div class="image-wrapper_8 flex-row lanhu-banner-dots" data-ready="1"><button type="button" class="lanhu-banner-dot" data-index="0" aria-label="轮播图1"></button><button type="button" class="lanhu-banner-dot is-active" data-index="1" aria-label="轮播图2"></button><button type="button" class="lanhu-banner-dot" data-index="2" aria-label="轮播图3"></button></div>
      </div>
      <div class="group_1 flex-row justify-between">
        <div class="section_1 flex-col justify-between"><a class="lanhu-card-link" href="/home/index" rel="noopener">
            <div class="group_2 flex-col"><span class="text_3">住建行业培训报名</span>
              <div class="image-wrapper_1 flex-col"><img class="label_1" src="/static/assets/img/ncportal/label_1.png"></div>
            </div>
          </a>
          <div class="group_3 flex-col"><span class="text_4">职业技能认定培训报名</span>
            <div class="image-wrapper_2 flex-col"><img class="label_2" src="/static/assets/img/ncportal/label_1.png"></div>
          </div>
        </div>
        <div class="section_2 flex-col">
          <div class="group_4 flex-row">
            <span class="text_5">培训要闻</span>
            <div class="section_3 flex-col"></div>
            <div class="image-text_1 flex-row justify-between">
              <span class="text-group_1"><a href="/portal/newlist?t=3" class="lanhu-more-link">查看更多</a></span><img class="thumbnail_1" src="/static/assets/img/ncportal/thumbnail_1.png">
            </div>
            <span class="text_6">干部培训</span>
            <div class="section_4 flex-col"></div>
            <div class="image-text_2 flex-row">
              <span class="text-group_2"><a href="/portal/newlist?t=4" class="lanhu-more-link">查看更多</a></span><img class="thumbnail_2" src="/static/assets/img/ncportal/thumbnail_2.png">
            </div>
          </div>
          <div class="flex-row">
            <div style="width: 472px;">
              <div class="text-wrapper_1 flex-row" v-for="item in news3" :key="item.Id">
                <span class="text_7"><a href="/portal/newlist?t=5" class="lanhu-news-link">{{item.Title}}</a></span><span class="text_8">{{item.PublishTime | dateformat}}</span>
              </div>
            </div>
            <div style="width: 472px;">
              <div class="text-wrapper_1 flex-row" v-for="item in news4" :key="item.Id">
                <span class="text_7"><a href="/portal/newlist?t=6" class="lanhu-news-link">{{item.Title}}</a></span><span class="text_8">{{item.PublishTime | dateformat}}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="group_5 flex-row justify-between">
        <div class="group_6 flex-col justify-between">
          <a class="lanhu-card-link" href="/portal/newlist?t=9" rel="noopener">
            <div class="group_7 flex-col">
              <div class="image-text_3 flex-row justify-between"><img class="image_2" src="/static/assets/img/ncportal/image_2.png"><span class="text-group_3">工匠课堂</span></div>
              <div class="image-wrapper_3 flex-col"><img class="label_3" src="/static/assets/img/ncportal/label_1.png"></div>
            </div>
          </a>
          <a class="lanhu-card-link" href="/portal/newlist?t=10" rel="noopener">
            <div class="group_8 flex-col"><span class="text_19">师资培训</span>
              <div class="image-wrapper_4 flex-col"><img class="label_4" src="/static/assets/img/ncportal/label_1.png"></div>
            </div>
          </a>
        </div>
        <div class="group_9 flex-col">
          <div class="group_10 flex-row"><span class="text_20">技能培训</span>
            <div class="box_3 flex-col"></div>
            <div class="image-text_4 flex-row"><span class="text-group_4"><a href="/portal/newlist?t=7" class="lanhu-more-link">查看更多</a></span><img class="thumbnail_3" src="/static/assets/img/ncportal/thumbnail_2.png"></div><span class="text_21">特种培训</span>
            <div class="box_4 flex-col"></div>
            <div class="image-text_5 flex-row"><span class="text-group_5"><a href="/portal/newlist?t=8" class="lanhu-more-link">查看更多</a></span><img class="thumbnail_4" src="/static/assets/img/ncportal/thumbnail_2.png"></div>
          </div>
          <div class="flex-row">
            <div style="width: 472px;">
              <div class="text-wrapper_1 flex-row" v-for="item in news5" :key="item.Id">
                <span class="text_7"><a href="/article/news-1" class="lanhu-news-link">{{item.Title}}</a></span><span class="text_8">{{item.PublishTime | dateformat}}</span>
              </div>
            </div>
            <div style="width: 472px;">
              <div class="text-wrapper_1 flex-row" v-for="item in news6" :key="item.Id">
                <span class="text_7"><a href="/article/news-1" class="lanhu-news-link">{{item.Title}}</a></span><span class="text_8">{{item.PublishTime | dateformat}}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="group_11 flex-row justify-between">
        <div class="block_1 flex-col justify-between">

          <a class="lanhu-card-link" href="/portal/newlist?t=11" rel="noopener">
            <div class="section_5 flex-col"><span class="text_34">退役军人培训</span>
              <div class="image-wrapper_5 flex-col"><img class="label_5" src="/static/assets/img/ncportal/label_1.png"></div>
            </div>
          </a>
          <div class="section_6 flex-col"><span class="text_35">证书查询</span>
            <div class="image-wrapper_6 flex-col"><img class="label_6" src="/static/assets/img/ncportal/label_1.png"></div>
          </div>
        </div>
        <div class="block_2 flex-col">
          <div class="group_12 flex-row"><span class="text_36">专项培训</span>
            <div class="group_13 flex-col"></div>
            <div class="image-text_6 flex-row"><span class="text-group_6"><a href="/special" class="lanhu-more-link">查看更多</a></span><img class="thumbnail_5" src="/static/assets/img/ncportal/thumbnail_2.png"></div><span class="text_37">评价通告</span>
            <div class="group_14 flex-col"></div>
            <div class="image-text_7 flex-row"><span class="text-group_7"><a href="/notice" class="lanhu-more-link">查看更多</a></span><img class="thumbnail_6" src="/static/assets/img/ncportal/thumbnail_2.png"></div>
          </div>
          <div class="flex-row">
            <div style="width: 472px;">
              <div class="text-wrapper_1 flex-row" v-for="item in news7" :key="item.Id">
                <span class="text_7"><a href="/article/news-1" class="lanhu-news-link">{{item.Title}}</a></span><span class="text_8">{{item.PublishTime | dateformat}}</span>
              </div>
            </div>
            <div style="width: 472px;">
              <div class="text-wrapper_1 flex-row" v-for="item in news8" :key="item.Id">
                <span class="text_7"><a href="/article/news-1" class="lanhu-news-link">{{item.Title}}</a></span><span class="text_8">{{item.PublishTime | dateformat}}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="lanhu-qr-section flex-row">
        <div class="lanhu-qr-col flex-col"><img class="image_3-0" src="/static/assets/img/ncportal/image_3.png"><span class="text_50">学院公众号</span></div>
        <div class="lanhu-qr-col flex-col"><img class="image_3-1" src="/static/assets/img/ncportal/image_3_2.png"><span class="text_51">学院视频号</span></div>
        <div class="lanhu-qr-col flex-col"><img class="image_3-2" src="/static/assets/img/ncportal/image_3_3.png"><span class="text_52">学院抖音号</span></div>
        <div class="lanhu-qr-col flex-col"><img class="image_3-3" src="/static/assets/img/ncportal/image_3_2.png"><span class="text_53">学院培训号</span></div>
        <div class="lanhu-qr-col flex-col"><img class="image_3-3" src="/static/assets/img/ncportal/image_3_4.png"><span class="text_53">宣传视频</span></div>
      </div>
    </div>
    <div class="box_5 flex-col">
      <div class="group_19 flex-row justify-between">
        <div class="image-text_8 flex-row justify-between"><img class="image_5" src="/static/assets/img/ncportal/image_5.png"><span class="text-group_9">南昌技师学院培训服务平台</span></div><span class="text_65">赣公网安备36010802001159号&nbsp;&nbsp;&nbsp;赣1CP备2024032715号</span>
      </div>
      <div class="image-wrapper_9 flex-row"><img class="label_7" src="/static/assets/img/ncportal/label_7.png"><img class="label_8" src="/static/assets/img/ncportal/label_8.png"><img class="label_9" src="/static/assets/img/ncportal/label_9.png"></div>
      <div class="text-wrapper_12 flex-row justify-between"><span class="paragraph_1">地址:江西省南昌市红谷滩区复兴大道西3499号<br><br>邮编:330001</span><span class="paragraph_2">三类业务咨询:15279177006张老师<br>特种业务咨询:15279177006张老师<br>技术工人业务咨询:15279177006张老师<br>十大员业务咨询:17379117878魏老师</span><span class="paragraph_3">收款户名:南昌技师学院<br>收款账号:1502207029081005612-000000002<br>收款银行:中国工商银行股份有限公司南昌胜利支行<br>缴费群号:522613967</span></div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'home',
  data() {
    return {
      news3: [],
      news4: [],
      news5: [],
      news6: [],
      news7: [],
      news8: []
    }
  },
  filters: {
    dateformat(dataStr, pattern = 'YYYY-MM-DD HH:mm') {
      if (dataStr === null) {
        return '';
      }
      return moment(dataStr).format(pattern)
    }
  },
  mounted() {
    this.$store.dispatch('getNews', { newsCategoryId: 3, length: 3 }).then(res => {
      this.news3 = res.Data;
    });
    this.$store.dispatch('getNews', { newsCategoryId: 4, length: 3 }).then(res => {
      this.news4 = res.Data;
    });
    this.$store.dispatch('getNews', { newsCategoryId: 5, length: 3 }).then(res => {
      this.news5 = res.Data;
    });
    this.$store.dispatch('getNews', { newsCategoryId: 6, length: 3 }).then(res => {
      this.news6 = res.Data;
    });
    this.$store.dispatch('getNews', { newsCategoryId: 7, length: 3 }).then(res => {
      this.news7 = res.Data;
    });
    this.$store.dispatch('getNews', { newsCategoryId: 8, length: 3 }).then(res => {
      this.news8 = res.Data;
    });
  },
  methods: {
    toNewList(newsCategoryId) {
      this.$router.push({ name: 'portalnewlist', query: { t: newsCategoryId } });
    }
  }
}
</script>
<style scoped>
.page {
  background-color: #f7f8fc;
  overflow: hidden;
  position: relative;
  width: 100%;
}

.box_1 {
  background: url(/static/assets/img/ncportal/box_1.png) 100% no-repeat;
  background-size: 100% 100%;
  height: 217px;
  width: 100%;
}

.box_1_1 {
  width: 1400px;
  margin: 0 auto;
  display: flex;
  justify-content: start;
  align-items: center;
}

.image_1 {
  height: 122px;
  width: 122px;
}

.text_1 {
  font-family: Source Han Sans CN-Bold;
  font-size: 48px;
  font-weight: 700;
  height: 77px;
  margin-left: 22px;
  width: 616px;
  margin-left: 22px;
}

.text_1,
.text_2 {
  color: #fff;
  overflow-wrap: break-word;
  text-align: left;
  white-space: nowrap;
}

.text_2 {
  font-family: Source Han Sans CN-Medium;
  font-size: 40px;
  font-weight: 500;
  line-height: 40px;
  width: 449px;
  margin-left: 185px;
}

.box_2 {
  position: relative;
  width: 100%;
  background-color: #fff;
}

.group_1 {
  height: 324px;
  margin: 64px auto 0 auto;
  width: 1400px;
}

.section_1 {
  height: 316px;
  width: 443px;
}

.group_2 {
  background: url(/static/assets/img/ncportal/group_2.png) 100% no-repeat;
  background-size: 100% 100%;
  height: 143px;
  width: 443px;
}

.text_3 {
  color: #fff;
  font-family: Source Han Sans CN-Medium;
  font-size: 33.1065673828px;
  font-weight: 500;
  height: 43px;
  line-height: 33.1065673828px;
  margin: 13px 0 0 30px;
  overflow-wrap: break-word;
  text-align: left;
  white-space: nowrap;
  width: 332px;
}

.image-wrapper_1 {
  border: 2.2824494839px solid #fff;
  border-radius: 50%;
  height: 30px;
  margin: 29px 0 28px 38px;
  width: 30px;
}

.label_1 {
  height: 21px;
  margin: 2px 0 0 2px;
  width: 21px;
}

.group_3 {
  background: url(/static/assets/img/ncportal/group_3.png) 100% no-repeat;
  background-size: 100% 100%;
  height: 143px;
  margin: 30px 0 0;
  width: 443px;
}

.text_4 {
  color: #fff;
  font-family: Source Han Sans CN-Medium;
  font-size: 33.1065673828px;
  font-weight: 500;
  height: 43px;
  line-height: 33.1065673828px;
  margin: 19px 0 0 30px;
  overflow-wrap: break-word;
  text-align: left;
  white-space: nowrap;
  width: 414px;
}

.image-wrapper_2 {
  border: 2.2824494839px solid #fff;
  border-radius: 50%;
  height: 30px;
  margin: 23px 0 28px 38px;
  width: 30px;
}

.label_2 {
  height: 21px;
  margin: 2px 0 0 2px;
  width: 21px;
}

.section_2 {
  background-color: #fff;
  border-radius: 14px;
  height: 324px;
  width: 941px;
}

.group_4 {
  height: 49px;
  margin: 21px 0 0 20px;
  width: 900px;
}

.text_5 {
  color: #000;
  font-family: Source Han Sans CN-Medium;
  font-size: 32px;
  font-weight: 500;
  height: 48px;
  line-height: 32px;
  overflow-wrap: break-word;
  text-align: left;
  white-space: nowrap;
  width: 136px;
}

.section_3 {
  background-color: #1c94fa;
  height: 6px;
  margin: 43px 0 0 -67px;
  width: 55px;
}

.image-text_1 {
  height: 36px;
  margin: 6px 0 0 184px;
  width: 116px;
}

.text-group_1 {
  color: #1c94fa;
  font-family: Source Han Sans CN-Medium;
  font-size: 24px;
  font-weight: 500;
  height: 36px;
  line-height: 24px;
  overflow-wrap: break-word;
  text-align: left;
  white-space: nowrap;
  width: 96px;
}

.thumbnail_1 {
  height: 20px;
  margin: 7px 0 0;
  width: 20px;
}

.text_6 {
  color: #000;
  font-family: Source Han Sans CN-Medium;
  font-size: 32px;
  font-weight: 500;
  height: 48px;
  line-height: 32px;
  margin: 0 0 0 49px;
  overflow-wrap: break-word;
  text-align: left;
  white-space: nowrap;
  width: 136px;
}

.section_4 {
  background-color: #1c94fa;
  height: 6px;
  margin: 43px 0 0 -132px;
  width: 55px;
}

.image-text_2 {
  height: 36px;
  margin: 6px 0 0 253px;
  width: 115px;
}

.text-group_2 {
  color: #1c94fa;
  font-family: Source Han Sans CN-Medium;
  font-size: 24px;
  font-weight: 500;
  height: 36px;
  line-height: 24px;
  overflow-wrap: break-word;
  text-align: left;
  white-space: nowrap;
  width: 96px;
}

.thumbnail_2 {
  height: 17px;
  margin: 22px -3px 0 5px;
  width: 17px;
}

.text-wrapper_1 {
  height: 30px;
  margin: 37px 0 0 23px;
  width: 100%;
}

.text_7 {
  color: #000;
  font-family: Source Han Sans CN-Medium;
  font-size: 20px;
  font-weight: 500;
  height: 30px;
  line-height: 20px;
  width: 230px;
}

.text_7,
.text_8 {
  overflow-wrap: break-word;
  text-align: left;
  white-space: nowrap;
}

.text_8 {
  color: #4d4d4d;
  font-family: Source Han Sans CN-Normal;
  font-size: 16px;
  font-weight: 400;
  height: 24px;
  line-height: 16px;
  margin: 3px 0 0 47px;
  width: 147px;
}

.text_9 {
  color: #000;
  font-family: Source Han Sans CN-Medium;
  font-size: 20px;
  font-weight: 500;
  height: 30px;
  line-height: 20px;
  margin: 0 0 0 47px;
  width: 230px;
}

.text_10,
.text_9 {
  overflow-wrap: break-word;
  text-align: left;
  white-space: nowrap;
}

.text_10 {
  color: #4d4d4d;
  font-family: Source Han Sans CN-Normal;
  font-size: 16px;
  font-weight: 400;
  height: 24px;
  line-height: 16px;
  margin: 3px 0 0 46px;
  width: 147px;
}

.text-wrapper_2 {
  height: 30px;
  margin: 52px 0 0 23px;
  width: 894px;
}

.text_11 {
  color: #000;
  font-family: Source Han Sans CN-Medium;
  font-size: 20px;
  font-weight: 500;
  height: 30px;
  line-height: 20px;
  width: 238px;
}

.text_11,
.text_12 {
  overflow-wrap: break-word;
  text-align: left;
  white-space: nowrap;
}

.text_12 {
  color: #4d4d4d;
  font-family: Source Han Sans CN-Normal;
  font-size: 16px;
  font-weight: 400;
  height: 24px;
  line-height: 16px;
  margin: 3px 0 0 39px;
  width: 147px;
}

.text_13 {
  color: #000;
  font-family: Source Han Sans CN-Medium;
  font-size: 20px;
  font-weight: 500;
  height: 30px;
  line-height: 20px;
  margin: 0 0 0 47px;
  width: 238px;
}

.text_13,
.text_14 {
  overflow-wrap: break-word;
  text-align: left;
  white-space: nowrap;
}

.text_14 {
  color: #4d4d4d;
  font-family: Source Han Sans CN-Normal;
  font-size: 16px;
  font-weight: 400;
  height: 24px;
  line-height: 16px;
  margin: 3px 0 0 38px;
  width: 147px;
}

.text-wrapper_3 {
  height: 30px;
  margin: 50px 0 25px 23px;
  width: 893px;
}

.text_15 {
  color: #000;
  font-family: Source Han Sans CN-Medium;
  font-size: 20px;
  font-weight: 500;
  height: 30px;
  line-height: 20px;
  width: 230px;
}

.text_15,
.text_16 {
  overflow-wrap: break-word;
  text-align: left;
  white-space: nowrap;
}

.text_16 {
  color: #4d4d4d;
  font-family: Source Han Sans CN-Normal;
  font-size: 16px;
  font-weight: 400;
  height: 24px;
  line-height: 16px;
  margin: 3px 0 0 45px;
  width: 147px;
}

.text_17 {
  color: #000;
  font-family: Source Han Sans CN-Medium;
  font-size: 20px;
  font-weight: 500;
  height: 30px;
  line-height: 20px;
  margin: 0 0 0 49px;
  width: 230px;
}

.text_17,
.text_18 {
  overflow-wrap: break-word;
  text-align: left;
  white-space: nowrap;
}

.text_18 {
  color: #4d4d4d;
  font-family: Source Han Sans CN-Normal;
  font-size: 16px;
  font-weight: 400;
  height: 24px;
  line-height: 16px;
  margin: 3px 0 0 45px;
  width: 147px;
}

.group_5 {
  height: 324px;
  margin: 20px auto 0 auto;
  width: 1400px;
}

.group_6 {
  height: 316px;
  margin: 2px 0 0;
  width: 443px;
}

.group_7 {
  background: url(/static/assets/img/ncportal/group_7.png) 100% no-repeat;
  background-size: 100% 100%;
  height: 143px;
  width: 443px;
}

.image-text_3 {
  height: 53px;
  margin: 16px 0 0 27px;
  width: 194px;
}

.image_2 {
  height: 51px;
  margin: 2px 0 0;
  width: 51px;
}

.text-group_3 {
  color: #fff;
  font-family: Source Han Sans CN-Medium;
  font-size: 33.1065673828px;
  font-weight: 500;
  height: 50px;
  line-height: 33.1065673828px;
  overflow-wrap: break-word;
  text-align: left;
  white-space: nowrap;
  width: 133px;
}

.image-wrapper_3 {
  border: 2.2824494839px solid #fff;
  border-radius: 50%;
  height: 30px;
  margin: 16px 0 28px 38px;
  width: 30px;
}

.label_3 {
  height: 21px;
  margin: 2px 0 0 2px;
  width: 21px;
}

.group_8 {
  background: url(/static/assets/img/ncportal/group_8.png) 100% no-repeat;
  background-size: 100% 100%;
  height: 143px;
  margin: 30px 0 0;
  width: 443px;
}

.text_19 {
  color: #fff;
  font-family: Source Han Sans CN-Medium;
  font-size: 33.1065673828px;
  font-weight: 500;
  height: 43px;
  line-height: 33.1065673828px;
  margin: 17px 0 0 32px;
  overflow-wrap: break-word;
  text-align: left;
  white-space: nowrap;
  width: 133px;
}

.image-wrapper_4 {
  border: 2.2824494839px solid #fff;
  border-radius: 50%;
  height: 30px;
  margin: 25px 0 28px 38px;
  width: 30px;
}

.label_4 {
  height: 21px;
  margin: 2px 0 0 2px;
  width: 21px;
}

.group_9 {
  background-color: #fff;
  border-radius: 14px;
  height: 324px;
  width: 941px;
}

.group_10 {
  height: 49px;
  margin: 21px 0 0 20px;
  width: 900px;
}

.text_20 {
  color: #000;
  font-family: Source Han Sans CN-Medium;
  font-size: 32px;
  font-weight: 500;
  height: 48px;
  line-height: 32px;
  overflow-wrap: break-word;
  text-align: left;
  white-space: nowrap;
  width: 136px;
}

.box_3 {
  background-color: #1c94fa;
  height: 6px;
  margin: 43px 0 0 -67px;
  width: 55px;
}

.image-text_4 {
  height: 36px;
  margin: 6px 0 0 184px;
  width: 115px;
}

.text-group_4 {
  color: #1c94fa;
  font-family: Source Han Sans CN-Medium;
  font-size: 24px;
  font-weight: 500;
  height: 36px;
  line-height: 24px;
  overflow-wrap: break-word;
  text-align: left;
  white-space: nowrap;
  width: 96px;
}

.thumbnail_3 {
  height: 17px;
  margin: 22px -3px 0 5px;
  width: 17px;
}

.text_21 {
  color: #000;
  font-family: Source Han Sans CN-Medium;
  font-size: 32px;
  font-weight: 500;
  height: 48px;
  line-height: 32px;
  margin: 0 0 0 50px;
  overflow-wrap: break-word;
  text-align: left;
  white-space: nowrap;
  width: 136px;
}

.box_4 {
  background-color: #1c94fa;
  height: 6px;
  margin: 43px 0 0 -132px;
  width: 55px;
}

.image-text_5 {
  height: 36px;
  margin: 6px 0 0 253px;
  width: 115px;
}

.text-group_5 {
  color: #1c94fa;
  font-family: Source Han Sans CN-Medium;
  font-size: 24px;
  font-weight: 500;
  height: 36px;
  line-height: 24px;
  overflow-wrap: break-word;
  text-align: left;
  white-space: nowrap;
  width: 96px;
}

.thumbnail_4 {
  height: 17px;
  margin: 22px -3px 0 5px;
  width: 17px;
}

.text-wrapper_4 {
  height: 30px;
  margin: 37px 0 0 23px;
  width: 894px;
}

.text_22 {
  color: #000;
  font-family: Source Han Sans CN-Medium;
  font-size: 20px;
  font-weight: 500;
  height: 30px;
  line-height: 20px;
  width: 230px;
}

.text_22,
.text_23 {
  overflow-wrap: break-word;
  text-align: left;
  white-space: nowrap;
}

.text_23 {
  color: #4d4d4d;
  font-family: Source Han Sans CN-Normal;
  font-size: 16px;
  font-weight: 400;
  height: 24px;
  line-height: 16px;
  margin: 3px 0 0 47px;
  width: 147px;
}

.text_24 {
  color: #000;
  font-family: Source Han Sans CN-Medium;
  font-size: 20px;
  font-weight: 500;
  height: 30px;
  line-height: 20px;
  margin: 0 0 0 47px;
  width: 230px;
}

.text_24,
.text_25 {
  overflow-wrap: break-word;
  text-align: left;
  white-space: nowrap;
}

.text_25 {
  color: #4d4d4d;
  font-family: Source Han Sans CN-Normal;
  font-size: 16px;
  font-weight: 400;
  height: 24px;
  line-height: 16px;
  margin: 3px 0 0 46px;
  width: 147px;
}

.text-wrapper_5 {
  height: 30px;
  margin: 52px 0 0 23px;
  width: 894px;
}

.text_26 {
  color: #000;
  font-family: Source Han Sans CN-Medium;
  font-size: 20px;
  font-weight: 500;
  height: 30px;
  line-height: 20px;
  width: 238px;
}

.text_26,
.text_27 {
  overflow-wrap: break-word;
  text-align: left;
  white-space: nowrap;
}

.text_27 {
  color: #4d4d4d;
  font-family: Source Han Sans CN-Normal;
  font-size: 16px;
  font-weight: 400;
  height: 24px;
  line-height: 16px;
  margin: 3px 0 0 39px;
  width: 147px;
}

.text_28 {
  color: #000;
  font-family: Source Han Sans CN-Medium;
  font-size: 20px;
  font-weight: 500;
  height: 30px;
  line-height: 20px;
  margin: 0 0 0 47px;
  width: 238px;
}

.text_28,
.text_29 {
  overflow-wrap: break-word;
  text-align: left;
  white-space: nowrap;
}

.text_29 {
  color: #4d4d4d;
  font-family: Source Han Sans CN-Normal;
  font-size: 16px;
  font-weight: 400;
  height: 24px;
  line-height: 16px;
  margin: 3px 0 0 38px;
  width: 147px;
}

.text-wrapper_6 {
  height: 30px;
  margin: 50px 0 25px 23px;
  width: 893px;
}

.text_30 {
  color: #000;
  font-family: Source Han Sans CN-Medium;
  font-size: 20px;
  font-weight: 500;
  height: 30px;
  line-height: 20px;
  width: 230px;
}

.text_30,
.text_31 {
  overflow-wrap: break-word;
  text-align: left;
  white-space: nowrap;
}

.text_31 {
  color: #4d4d4d;
  font-family: Source Han Sans CN-Normal;
  font-size: 16px;
  font-weight: 400;
  height: 24px;
  line-height: 16px;
  margin: 3px 0 0 45px;
  width: 147px;
}

.text_32 {
  color: #000;
  font-family: Source Han Sans CN-Medium;
  font-size: 20px;
  font-weight: 500;
  height: 30px;
  line-height: 20px;
  margin: 0 0 0 49px;
  width: 230px;
}

.text_32,
.text_33 {
  overflow-wrap: break-word;
  text-align: left;
  white-space: nowrap;
}

.text_33 {
  color: #4d4d4d;
  font-family: Source Han Sans CN-Normal;
  font-size: 16px;
  font-weight: 400;
  height: 24px;
  line-height: 16px;
  margin: 3px 0 0 45px;
  width: 147px;
}

.group_11 {
  height: 324px;
  margin: 20px auto 0 auto;
  width: 1400px;
}

.block_1 {
  height: 316px;
  margin: 4px 0 0;
  width: 443px;
}

.section_5 {
  background: url(/static/assets/img/ncportal/section_5.png) 100% no-repeat;
  background-size: 100% 100%;
  height: 143px;
  width: 443px;
}

.text_34 {
  color: #fff;
  font-family: Source Han Sans CN-Medium;
  font-size: 33.1065673828px;
  font-weight: 500;
  height: 43px;
  line-height: 33.1065673828px;
  margin: 20px 0 0 32px;
  overflow-wrap: break-word;
  text-align: left;
  white-space: nowrap;
  width: 199px;
}

.image-wrapper_5 {
  border: 2.2824494839px solid #fff;
  border-radius: 50%;
  height: 30px;
  margin: 22px 0 28px 38px;
  width: 30px;
}

.label_5 {
  height: 21px;
  margin: 2px 0 0 2px;
  width: 21px;
}

.section_6 {
  background: url(/static/assets/img/ncportal/section_6.png) 100% no-repeat;
  background-size: 100% 100%;
  height: 143px;
  margin: 30px 0 0;
  width: 443px;
}

.text_35 {
  color: #fff;
  font-family: Source Han Sans CN-Medium;
  font-size: 33.1065673828px;
  font-weight: 500;
  height: 50px;
  line-height: 33.1065673828px;
  margin: 20px 0 0 32px;
  overflow-wrap: break-word;
  text-align: left;
  white-space: nowrap;
  width: 133px;
}

.image-wrapper_6 {
  border: 2.2824494839px solid #fff;
  border-radius: 50%;
  height: 30px;
  margin: 15px 0 28px 38px;
  width: 30px;
}

.label_6 {
  height: 21px;
  margin: 2px 0 0 2px;
  width: 21px;
}

.block_2 {
  background-color: #fff;
  border-radius: 14px;
  height: 324px;
  width: 941px;
}

.group_12 {
  height: 49px;
  margin: 21px 0 0 20px;
  width: 900px;
}

.text_36 {
  color: #000;
  font-family: Source Han Sans CN-Medium;
  font-size: 32px;
  font-weight: 500;
  height: 48px;
  line-height: 32px;
  overflow-wrap: break-word;
  text-align: left;
  white-space: nowrap;
  width: 136px;
}

.group_13 {
  background-color: #1c94fa;
  height: 6px;
  margin: 43px 0 0 -67px;
  width: 55px;
}

.image-text_6 {
  height: 36px;
  margin: 6px 0 0 184px;
  width: 115px;
}

.text-group_6 {
  color: #1c94fa;
  font-family: Source Han Sans CN-Medium;
  font-size: 24px;
  font-weight: 500;
  height: 36px;
  line-height: 24px;
  overflow-wrap: break-word;
  text-align: left;
  white-space: nowrap;
  width: 96px;
}

.thumbnail_5 {
  height: 17px;
  margin: 22px -3px 0 5px;
  width: 17px;
}

.text_37 {
  color: #000;
  font-family: Source Han Sans CN-Medium;
  font-size: 32px;
  font-weight: 500;
  height: 48px;
  line-height: 32px;
  margin: 0 0 0 50px;
  overflow-wrap: break-word;
  text-align: left;
  white-space: nowrap;
  width: 136px;
}

.group_14 {
  background-color: #1c94fa;
  height: 6px;
  margin: 43px 0 0 -132px;
  width: 55px;
}

.image-text_7 {
  height: 36px;
  margin: 6px 0 0 253px;
  width: 115px;
}

.text-group_7 {
  color: #1c94fa;
  font-family: Source Han Sans CN-Medium;
  font-size: 24px;
  font-weight: 500;
  height: 36px;
  line-height: 24px;
  overflow-wrap: break-word;
  text-align: left;
  white-space: nowrap;
  width: 96px;
}

.thumbnail_6 {
  height: 17px;
  margin: 22px -3px 0 5px;
  width: 17px;
}

.text-wrapper_7 {
  height: 30px;
  margin: 37px 0 0 23px;
  width: 894px;
}

.text_38 {
  color: #000;
  font-family: Source Han Sans CN-Medium;
  font-size: 20px;
  font-weight: 500;
  height: 30px;
  line-height: 20px;
  width: 230px;
}

.text_38,
.text_39 {
  overflow-wrap: break-word;
  text-align: left;
  white-space: nowrap;
}

.text_39 {
  color: #4d4d4d;
  font-family: Source Han Sans CN-Normal;
  font-size: 16px;
  font-weight: 400;
  height: 24px;
  line-height: 16px;
  margin: 3px 0 0 47px;
  width: 147px;
}

.text_40 {
  color: #000;
  font-family: Source Han Sans CN-Medium;
  font-size: 20px;
  font-weight: 500;
  height: 30px;
  line-height: 20px;
  margin: 0 0 0 47px;
  width: 230px;
}

.text_40,
.text_41 {
  overflow-wrap: break-word;
  text-align: left;
  white-space: nowrap;
}

.text_41 {
  color: #4d4d4d;
  font-family: Source Han Sans CN-Normal;
  font-size: 16px;
  font-weight: 400;
  height: 24px;
  line-height: 16px;
  margin: 3px 0 0 46px;
  width: 147px;
}

.text-wrapper_8 {
  height: 30px;
  margin: 52px 0 0 23px;
  width: 894px;
}

.text_42 {
  color: #000;
  font-family: Source Han Sans CN-Medium;
  font-size: 20px;
  font-weight: 500;
  height: 30px;
  line-height: 20px;
  width: 238px;
}

.text_42,
.text_43 {
  overflow-wrap: break-word;
  text-align: left;
  white-space: nowrap;
}

.text_43 {
  color: #4d4d4d;
  font-family: Source Han Sans CN-Normal;
  font-size: 16px;
  font-weight: 400;
  height: 24px;
  line-height: 16px;
  margin: 3px 0 0 39px;
  width: 147px;
}

.text_44 {
  color: #000;
  font-family: Source Han Sans CN-Medium;
  font-size: 20px;
  font-weight: 500;
  height: 30px;
  line-height: 20px;
  margin: 0 0 0 47px;
  width: 238px;
}

.text_44,
.text_45 {
  overflow-wrap: break-word;
  text-align: left;
  white-space: nowrap;
}

.text_45 {
  color: #4d4d4d;
  font-family: Source Han Sans CN-Normal;
  font-size: 16px;
  font-weight: 400;
  height: 24px;
  line-height: 16px;
  margin: 3px 0 0 38px;
  width: 147px;
}

.text-wrapper_9 {
  height: 30px;
  margin: 50px 0 25px 23px;
  width: 893px;
}

.text_46 {
  color: #000;
  font-family: Source Han Sans CN-Medium;
  font-size: 20px;
  font-weight: 500;
  height: 30px;
  line-height: 20px;
  width: 230px;
}

.text_46,
.text_47 {
  overflow-wrap: break-word;
  text-align: left;
  white-space: nowrap;
}

.text_47 {
  color: #4d4d4d;
  font-family: Source Han Sans CN-Normal;
  font-size: 16px;
  font-weight: 400;
  height: 24px;
  line-height: 16px;
  margin: 3px 0 0 45px;
  width: 147px;
}

.text_48 {
  color: #000;
  font-family: Source Han Sans CN-Medium;
  font-size: 20px;
  font-weight: 500;
  height: 30px;
  line-height: 20px;
  margin: 0 0 0 49px;
  width: 230px;
}

.text_48,
.text_49 {
  overflow-wrap: break-word;
  text-align: left;
  white-space: nowrap;
}

.text_49 {
  color: #4d4d4d;
  font-family: Source Han Sans CN-Normal;
  font-size: 16px;
  font-weight: 400;
  height: 24px;
  line-height: 16px;
  margin: 3px 0 0 45px;
  width: 147px;
}

.image-wrapper_7-0,
.image-wrapper_7-1,
.image-wrapper_7-2,
.image-wrapper_7-3 {
  height: 207px;
  margin: 112px 0 0 297px;
  width: 1332px;
}

.image_3-0,
.image_3-1,
.image_3-2,
.image_3-3 {
  height: 207px;
  margin: 0 168px 0 0;
  width: 207px;
}

.text-wrapper_10 {
  height: 45px;
  margin: 40px 0 79px 314px;
  width: 1287px;
}

.text_50,
.text_51 {
  color: #3d3d3d;
  font-family: Source Han Sans CN-Medium;
  font-size: 30.071559906px;
  font-weight: 500;
  height: 45px;
  line-height: 30.071559906px;
  overflow-wrap: break-word;
  text-align: left;
  white-space: nowrap;
  width: 151px;
}

.text_51 {
  margin: 0 0 0 235px;
}

.text_52 {
  margin: 0 0 0 225px;
}

.text_52,
.text_53 {
  color: #3d3d3d;
  font-family: Source Han Sans CN-Medium;
  font-size: 30.071559906px;
  font-weight: 500;
  height: 45px;
  line-height: 30.071559906px;
  overflow-wrap: break-word;
  text-align: left;
  white-space: nowrap;
  width: 151px;
}

.text_53 {
  margin: 0 0 0 223px;
}

.group_15 {
  background: url(/static/assets/img/ncportal/group_15.png) 100% no-repeat;
  background-size: 100% 100%;
  height: 451px;
  width: 100%;
  justify-content: center;
  align-items: center;
}

.group_16 {
  height: 232px;
  width: 1415px;
  margin-top: 89px;
}

.text-group_8 {
  height: 232px;
  width: 576px;
}

.text_54 {
  margin: 0 0 0 158px;
  width: 384px;
}

.text_54,
.text_55 {
  color: #fff;
  font-family: Source Han Sans CN-Bold;
  font-size: 64px;
  font-weight: 700;
  height: 96px;
  line-height: 64px;
  overflow-wrap: break-word;
  text-align: left;
  text-shadow: 0 6px 6px rgba(0, 0, 0, 0.25);
  white-space: nowrap;
}

.text_55 {
  margin: 40px 0 0;
  width: 576px;
}

.text-wrapper_11 {
  height: 232px;
  width: 772px;
}

.text_56 {
  width: 576px;
}

.text_56,
.text_57 {
  color: #fff;
  font-family: Source Han Sans CN-Bold;
  font-size: 64px;
  font-weight: 700;
  height: 96px;
  line-height: 64px;
  overflow-wrap: break-word;
  text-align: left;
  text-shadow: 0 6px 6px rgba(0, 0, 0, 0.25);
  white-space: nowrap;
}

.text_57 {
  margin: 40px 0 0 4px;
  width: 768px;
}

.image-wrapper_8 {
  margin: 89px 0 23px 0px;
}

.image-wrapper_8,
.image_4 {
  height: 18px;
  width: 90px;
}

.group_17 {
  background-color: #fff;
  height: 69px;
  justify-content: center;
  width: 1400px;
  margin: 0 auto;
}

.text_58 {
  color: #4d4d4d;
  font-family: Source Han Sans CN-Regular;
  font-size: 28px;
  font-weight: 400;
  height: 42px;
  line-height: 28px;
  margin: 10px 0 0 267px;
  overflow-wrap: break-word;
  text-align: left;
  white-space: nowrap;
  width: 56px;
}

.group_18 {
  background-color: #1c94fa;
  height: 3px;
  margin: 51px 0 0 -44px;
  width: 35px;
}

.text_59 {
  color: #4d4d4d;
  font-family: Source Han Sans CN-Normal;
  font-size: 28px;
  font-weight: 400;
  height: 42px;
  line-height: 28px;
  margin: 10px 0 0 84px;
  overflow-wrap: break-word;
  text-align: left;
  white-space: nowrap;
  width: 112px;
}

.text_60,
.text_61,
.text_62,
.text_63 {
  margin: 10px 0 0 75px;
}

.text_60,
.text_61,
.text_62,
.text_63,
.text_64 {
  color: #4d4d4d;
  font-family: Source Han Sans CN-Normal;
  font-size: 28px;
  font-weight: 400;
  height: 42px;
  line-height: 28px;
  overflow-wrap: break-word;
  text-align: left;
  white-space: nowrap;
  width: 112px;
}

.text_64 {
  margin: 10px 475px 0 75px;
}

.box_5 {
  background-color: #007de6;
  height: 334px;
  margin: -1px 0 0;
  width: 100%;
}

.group_19 {
  height: 67px;
  margin: 23px 0 0 265px;
  width: 1390px;
}

.image-text_8 {
  height: 67px;
  width: 368px;
}

.image_5 {
  height: 67px;
  width: 67px;
}

.text-group_9 {
  font-family: Source Han Sans CN-Bold;
  font-size: 23.6470584869px;
  font-weight: 700;
  height: 35px;
  line-height: 23.6470584869px;
  margin: 12px 0 0;
  width: 284px;
}

.text-group_9,
.text_65 {
  color: #fff;
  overflow-wrap: break-word;
  text-align: left;
  white-space: nowrap;
}

.text_65 {
  font-family: Source Han Sans CN-Normal;
  font-size: 16px;
  font-weight: 400;
  height: 24px;
  line-height: 16px;
  margin: 21px 0 0;
  width: 395px;
}

.image-wrapper_9 {
  height: 28px;
  margin: 59px 0 0 274px;
  width: 946px;
}

.label_7 {
  margin: 2px 0 0;
}

.label_7,
.label_8 {
  height: 26px;
  width: 26px;
}

.label_8 {
  margin: 0 0 0 462px;
}

.label_9 {
  height: 26px;
  margin: 0 0 0 406px;
  width: 26px;
}

.text-wrapper_12 {
  height: 112px;
  margin: 14px 0 31px 277px;
  width: 1274px;
}

.paragraph_1 {
  color: #fff;
  font-family: Source Han Sans CN-Normal;
  font-size: 16px;
  font-weight: 400;
  height: 56px;
  line-height: 28px;
  overflow-wrap: break-word;
  text-align: left;
  width: 331px;
}

.paragraph_2 {
  margin: 0 0 0 156px;
  width: 277px;
}

.paragraph_2,
.paragraph_3 {
  color: #fff;
  font-family: Source Han Sans CN-Normal;
  font-size: 16px;
  font-weight: 400;
  height: 112px;
  line-height: 28px;
  overflow-wrap: break-word;
  text-align: left;
}

.paragraph_3 {
  margin: 0 0 0 153px;
  width: 357px;
}

body * {
  box-sizing: border-box;
  flex-shrink: 0;
}

body {
  font-family: PingFangSC-Regular, Roboto, Helvetica Neue, Helvetica, Tahoma,
    Arial, PingFang SC-Light, Microsoft YaHei;
}

input {
  border: 0;
}

button,
input {
  background-color: transparent;
}

button {
  border: 1px solid transparent;
  margin: 0;
  outline: none;
  padding: 0;
}

button:active {
  opacity: 0.6;
}

.flex-col {
  display: flex;
  flex-direction: column;
}

.flex-row {
  display: flex;
  flex-direction: row;
}

.justify-start {
  display: flex;
  justify-content: flex-start;
}

.justify-center {
  display: flex;
  justify-content: center;
}

.justify-end {
  display: flex;
  justify-content: flex-end;
}

.justify-evenly {
  display: flex;
  justify-content: space-evenly;
}

.justify-around {
  display: flex;
  justify-content: space-around;
}

.justify-between {
  display: flex;
  justify-content: space-between;
}

.align-start {
  align-items: flex-start;
  display: flex;
}

.align-center {
  align-items: center;
  display: flex;
}

.align-end {
  align-items: flex-end;
  display: flex;
}

.lanhu-page .group_17 {
  align-items: center !important;
  box-sizing: border-box;
  height: 69px !important;
}

.lanhu-page .lanhu-nav-item {
  align-items: flex-start !important;
  box-sizing: border-box;
  height: 42px !important;
  justify-content: flex-start !important;
  margin-bottom: 0 !important;
  margin-top: 0 !important;
  padding-top: 7px;
  position: relative;
}

.lanhu-page .lanhu-nav-item a {
  display: block;
  height: 28px !important;
  line-height: 28px !important;
  margin: 0 !important;
  width: auto !important;
}

.lanhu-page .lanhu-nav-active {
  color: #1c94fa !important;
  font-weight: 500;
}

.lanhu-page .lanhu-nav-underline {
  background-color: #1c94fa !important;
  bottom: 0 !important;
  height: 3px !important;
  left: 0 !important;
  margin: 0 !important;
  position: absolute !important;
  width: 100% !important;
}

.lanhu-page .lanhu-banner {
  background-image: var(--lanhu-banner) !important;
  background-position: 50% !important;
  background-repeat: no-repeat !important;
  background-size: 100% 100% !important;
  left: 0 !important;
  transition: background-image 0.35s ease;
  width: 100% !important;
}

.lanhu-page .lanhu-banner-dots {
  align-items: center !important;
  cursor: default;
  display: flex !important;
  flex-direction: row !important;
  gap: 14px !important;
  justify-content: center !important;
  width: 90px !important;
}

.lanhu-page .lanhu-banner-dot {
  background-color: #b3b3b3;
  border: none;
  border-radius: 50%;
  cursor: pointer;
  flex-shrink: 0;
  height: 8px;
  padding: 0;
  width: 8px;
}

.lanhu-page .lanhu-banner-dot.is-active {
  background-color: #1c94fa;
}

.lanhu-page .lanhu-qr-section {
  align-items: flex-start !important;
  box-sizing: border-box;
  display: flex !important;
  flex-direction: row !important;
  justify-content: space-between !important;
  margin: 112px auto 79px auto !important;
  width: 1400px !important;
}

.lanhu-page .lanhu-qr-col {
  align-items: center !important;
  display: flex !important;
  flex-direction: column !important;
  flex-shrink: 0;
  gap: 40px;
  width: 207px !important;
}

.lanhu-page .lanhu-qr-col [class^='image_3'] {
  display: block;
  flex-shrink: 0;
  height: 207px !important;
  margin: 0 !important;
  -o-object-fit: contain;
  object-fit: contain;
  width: 207px !important;
}

.lanhu-page .lanhu-qr-col .text_50,
.lanhu-page .lanhu-qr-col .text_51,
.lanhu-page .lanhu-qr-col .text_52,
.lanhu-page .lanhu-qr-col .text_53 {
  height: auto !important;
  line-height: 1.2 !important;
  margin: 0 !important;
  text-align: center !important;
  white-space: nowrap;
  width: auto !important;
}

.lanhu-page [class^='image-text_'] {
  align-items: center !important;
  gap: 4px;
}

.lanhu-page [class^='image-text_'] [class^='text-group_'] {
  align-items: center;
  display: flex;
  height: auto !important;
  line-height: 1 !important;
}

.lanhu-page [class^='image-text_'] [class^='thumbnail_'] {
  align-self: center;
  display: block;
  flex-shrink: 0;
  margin: 0 !important;
}

.lanhu-page .box_5 {
  box-sizing: border-box;
  min-height: 334px;
  width: 100% !important;
}

.lanhu-page .box_5,
.lanhu-page .box_5 .group_19 {
  align-items: center !important;
  height: auto !important;
}

.lanhu-page .box_5 .group_19 {
  margin: 23px auto 0 !important;
  width: 1390px !important;
}

.lanhu-page .box_5 .image-text_8 {
  align-items: center !important;
  gap: 12px !important;
  height: auto !important;
  justify-content: flex-start !important;
  width: auto !important;
}

.lanhu-page .box_5 .image-text_8 .image_5 {
  flex-shrink: 0;
  margin: 0 !important;
}

.lanhu-page .box_5 .image-text_8 .text-group_9 {
  height: auto !important;
  line-height: 1.2 !important;
  margin: 0 !important;
  white-space: nowrap;
}

.lanhu-page .box_5 .text_65 {
  flex-shrink: 0;
  height: auto !important;
  margin: 0 !important;
}

.lanhu-page .box_5 .image-wrapper_9,
.lanhu-page .box_5 .text-wrapper_12 {
  box-sizing: border-box;
  display: grid !important;
  grid-template-columns: 371px 156px 310px 153px 400px;
  height: auto !important;
  margin-left: auto !important;
  margin-right: auto !important;
  max-width: 1390px;
  width: 1390px !important;
}

.lanhu-page .box_5 .image-wrapper_9 {
  align-items: center;
  margin-top: 40px !important;
}

.lanhu-page .box_5 .image-wrapper_9 .label_7 {
  grid-column: 1;
  height: 26px !important;
  margin: 0 !important;
  width: 26px !important;
}

.lanhu-page .box_5 .image-wrapper_9 .label_8 {
  grid-column: 3;
  height: 26px !important;
  margin: 0 !important;
  width: 26px !important;
}

.lanhu-page .box_5 .image-wrapper_9 .label_9 {
  grid-column: 5;
  height: 26px !important;
  margin: 0 !important;
  width: 26px !important;
}

.lanhu-page .box_5 .text-wrapper_12 {
  margin-bottom: 31px !important;
  margin-top: 14px !important;
  position: relative;
}

.lanhu-page .box_5 .text-wrapper_12:after,
.lanhu-page .box_5 .text-wrapper_12:before {
  align-self: stretch;
  background-color: #ffffff59;
  content: '';
  grid-row: 1;
  justify-self: center;
  width: 1px;
}

.lanhu-page .box_5 .text-wrapper_12:before {
  grid-column: 2;
}

.lanhu-page .box_5 .text-wrapper_12:after {
  grid-column: 4;
}

.lanhu-page .box_5 .paragraph_1 {
  grid-column: 1;
  height: auto !important;
  margin: 0 !important;
  width: auto !important;
}

.lanhu-page .box_5 .paragraph_2 {
  grid-column: 3;
  height: auto !important;
  margin: 0 !important;
  width: auto !important;
}

.lanhu-page .box_5 .paragraph_3 {
  grid-column: 5;
  height: auto !important;
  margin: 0 !important;
  width: auto !important;
}

.lanhu-page .lanhu-news-link {
  color: inherit;
  cursor: pointer;
  display: inline-block;
  max-width: 230px;
  overflow: hidden;
  text-overflow: ellipsis;
  transition: color 0.18s;
  vertical-align: top;
  white-space: nowrap;
}

.lanhu-page .lanhu-news-link:hover {
  color: #1c94fa;
}

.lanhu-page .lanhu-more-link {
  color: inherit;
  cursor: pointer;
  transition: color 0.18s;
}

.lanhu-page .lanhu-more-link:hover {
  color: #1c94fa;
}

.lanhu-page .lanhu-card-link {
  display: contents;
}

.lanhu-page .lanhu-card-link .group_2 {
  cursor: pointer;
  transition: opacity 0.18s, transform 0.18s;
}

.lanhu-page .lanhu-card-link .group_2:hover {
  opacity: 0.92;
  transform: translateY(-2px);
}

.lanhu-viewport {
  background-color: #f7f8fc;
  height: calc(2644 * 100vw / 1920);
  margin: 0;
  max-width: 100%;
  overflow: hidden;
  position: relative;
  width: 100vw;
}

.lanhu-stage {
  transform: scale(calc(100vw / 1920));
  transform-origin: top left;
  width: 1400px;
}

.lanhu-page a {
  color: inherit;
  cursor: pointer;
  text-decoration: none;
}
</style>



// WEBPACK FOOTER //
// src/views/portal/index.vue